import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * There is no home page — the app opens on Accounts (Kevin, 2026-08-26). A redirect rather
 * than a deletion so every existing `/app` link (the landing page's "Open app", the sign-in
 * return URL, bookmarks) still lands somewhere real.
 */
export const Route = createFileRoute('/app/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/accounts' })
  },
})
